<template>
  <div id="user-data">
    <vs-button
      style="float: right"
      color="black"
      class="mr-8 mb-4"
      @click="nextMonth(1)"
      >Next Month</vs-button
    >
    <vs-button
      style="float: right"
      color="black"
      class="mr-8 mb-4"
      @click="nextMonth(-1)"
      >Previous Month</vs-button
    >
    <vs-button
      style="float: right"
      color="primary"
      class="mr-8 mb-4"
      @click="GotoPayslip()"
      >Payslip</vs-button
    >   
    <vs-button
      style="float: right"
      color="primary"
      class="mr-8 mb-4"
      @click="Goto2dReport()"
      >Display 2D Report</vs-button
    >   
     <vs-button
      style="float: right"
      color="primary"
      class="mr-8 mb-4"
      @click="GotoUsages()"
      >Display Usages Report</vs-button
    >
    <div class="vx-row" id="page-user-view">
      <div class="vx-col lg:w-5/12 w-full">
        <vx-card title="Informations" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">Month</td>
              <td>{{ getMonth() }}</td>
            </tr>

            <tr>
              <td class="font-semibold">National Holiday</td>
              <td v-if="jourferier(yearInTop, monthInTop) > 1">
                {{ jourferier(yearInTop, monthInTop) }} days
              </td>
              <td v-else-if="jourferier(yearInTop, monthInTop) == 1">
                {{ jourferier(yearInTop, monthInTop) }} day
              </td>
              <td v-else>0 day</td>
            </tr>
            <tr>
              <td class="font-semibold">
                Working
                days&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>{{ workday_count() }} days</td>
            </tr>
            <tr>
              <td class="font-semibold">
                Working
                hours&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>{{ workday_count() * 8 }} hours</td>
            </tr>
          </table>
        </vx-card>
      </div>
    </div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <vs-button
            style="float: right"
            class="mt-4 mb-4 ml-4"
            @click="copyToClipboard('select_txt')"
            >Copy To Clipboard</vs-button
          >
          <template>
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row"></div>
              <template>
                <div>
                  <vs-table
                    id="select_txt"
                    ref="table"
                    :data="attendancespermonth"
                    search
                  >
                    <div
                      slot="header"
                      class="
                        flex flex-wrap-reverse
                        items-center
                        flex-grow
                        justify-between
                      "
                    >
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          data-list-btn-container
                        "
                      ></div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Employee</vs-th>
                      <vs-th>Jobtitle</vs-th>
                      <vs-th>Worked (hours)</vs-th>
                      <vs-th>Working (hours)</vs-th>
                      <vs-th>Extra (hours)</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <tbody>
                        <vs-tr
                          :data="tr"
                          :key="indextr"
                          v-for="(tr, indextr) in data"
                        >
                          <vs-td>
                            <p class="font-medium truncate">
                              {{ indextr + 1 }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p>
                              <b>{{ tr.person }}</b>
                            </p>
                          </vs-td>
                          <vs-td>
                            <p>{{ tr.jobtitle }}</p>
                          </vs-td>

                          <vs-td>
                            <p v-if="tr.worked && tr.worked.hours">
                              {{ padLeadingZeros(tr.worked.hours, 2) }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p>{{ parseInt(workingHours) }}</p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.worked && tr.worked.hours">{{ tr.worked.hours - workingHours }}</p>
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="ClockIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="ViewEmployee(tr.idperson)" />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template> </vs-table
                  ><br />
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleEmployeeList from "@/store/employee/moduleDataList.js";
import moment from "moment";
import momentbusiness from "moment-business-days";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      buttonSubmitOpen: false,
      state: {},
      workingHours: 0,
      workingDays: 0,
      monthInTop: 0,
      yearInTop: 0,
    };
  },
  computed: {
    attendancespermonth() {
      return this.$store.state.dataListEmployee.attendancespermonth;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.attendance_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.attendance_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    ViewEmployee(id) {
      window.location.replace("/web/employees/report/" + id);
    },
    GotoUsages() {
      window.location.replace("/web/employees/usages/"+this.$route.params.year+"/"+ this.$route.params.month);
    },
    GotoPayslip(){
      window.location.replace("/web/payslip");
    },
    Goto2dReport() {
      window.location.replace("/web/employees/monthly-report-2d/"+this.$route.params.year+"/"+ this.$route.params.month);
    },
    nextMonth(value) {
      if (value == -1) {
        if (this.$route.params.month == 1)
          window.location.replace(
            "/web/employees/monthly-report/" +
              (this.$route.params.year - 1) +
              "/12"
          );
        else
          window.location.replace(
            "/web/employees/monthly-report/" +
              this.$route.params.year +
              "/" +
              (this.$route.params.month - 1)
          );
      } else {
        if (this.$route.params.month == 12)
          window.location.replace(
            "/web/employees/monthly-report/" +
              (parseInt(this.$route.params.year) + 1) +
              "/01"
          );
        else
          window.location.replace(
            "/web/employees/monthly-report/" +
              this.$route.params.year +
              "/" +
              (parseInt(this.$route.params.month) + 1)
          );
      }
    },
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
    },
    getMonth() {
      return moment(
        this.$route.params.year + "-" + this.$route.params.month + "-01"
      ).format("MMMM YYYY");
    },
    jourferier(year, month) {
      let jourf = 0;
      if (month == 1) {
        let date1 = moment(year + "-" + month + "-01");
        let date2 = moment(year + "-" + month + "-02");
        let date3 = moment(year + "-" + month + "-24");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        if (momentbusiness(date3).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 4) {
        let date1 = moment(year + "-" + month + "-24");
        let date2 = moment(year + "-" + month + "-25");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 5) {
        let date1 = moment(year + "-" + month + "-01");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 6) {
        let date1 = moment(year + "-" + month + "-01");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 8) {
        let date1 = moment(year + "-" + month + "-15");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 11) {
        let date1 = moment(year + "-" + month + "-30");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 12) {
        let date1 = moment(year + "-" + month + "-01");
        let date2 = moment(year + "-" + month + "-25");
        let date3 = moment(year + "-" + month + "-26");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        if (momentbusiness(date3).isBusinessDay()) jourf++;
        return jourf;
      } else return 0;
    },
    workday_count() {
      let start = moment(
        this.$route.params.year + "-" + this.$route.params.month + "-01"
      ).format("YYYY-MM-DD");
      this.workingDays =
        momentbusiness(start).monthBusinessDays().length -
        this.jourferier(
          moment(start).format("YYYY"),
          moment(start).format("MM")
        );
      this.workingHours = this.workingDays * 8;
      return this.workingDays;
    },
    padLeadingZeros(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    tranformDate(dt) {
      const format1 = "YYYY-MM-DD HH:mm:ss";
      return moment(dt).format(format1);
    },
    fetchDataAttendanceListItems(year, month) {
      this.$store.dispatch("dataListEmployee/fetchattendancepermonth", {
        year,
        month,
      });
    },
  },

  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    } 
    if (!moduleEmployeeList.isRegistered) {
      this.$store.registerModule("dataListEmployee", moduleEmployeeList);
      moduleEmployeeList.isRegistered = true;
    }
    this.monthInTop = this.$route.params.month;
    this.yearInTop = this.$route.params.year;
    this.fetchDataAttendanceListItems(this.yearInTop, this.monthInTop);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
